import { ApiSet, BaseResponse, IndexApiSet, useIndexApi, usePutApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { PcrTestSample, PcrTestSampleForm, PcrTestSampleSearchForm } from 'entities/pcr_test_sample'

type PcrTestSamplesResponse = PagingResponse & {
    results: PcrTestSample[]
}

export function useFetchPcrTestSamplesApi(searchForm: Form<PcrTestSampleSearchForm>): IndexApiSet<PcrTestSamplesResponse> & { execute: () => void } {
    const apiPath = 'pcr_test_samples/'
    const api = useIndexApi<PcrTestSamplesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [api.pageSet.page, api.pageSet.perPage])

    return { ...api, execute: execute }
}

export function useBulkPutPcrTestSamplesApi(): ApiSet<BaseResponse> & { execute: (form: Form<PcrTestSampleForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, PcrTestSampleForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<PcrTestSampleForm[]>) => {
        const apiPath = `pcr_test_samples/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
